var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.multi_branding.length)?_c('div',{staticClass:"flex justify-center items-center q-pa-md"},_vm._l((_vm.multi_branding),function(multi_brand){return _c('div',{key:multi_brand.name},[_c('div',{staticClass:"q-ma-sm",staticStyle:{"height":"50px"}},[(
					_vm.registration_template_settings.template.enable_multi_branding &&
					multi_brand.logo &&
					!multi_brand.logo.endsWith('False')
					)?_c('img',{staticStyle:{"height":"inherit","width":"auto"},attrs:{"src":multi_brand.logo}}):_vm._e()])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }